// extracted by mini-css-extract-plugin
module.exports = {"container":"OfflineOrderDetailsPrintButton_container__1EX7D","text":"OfflineOrderDetailsPrintButton_text__3m7MN","text-ltr":"OfflineOrderDetailsPrintButton_text-ltr__3miF5"};